import { combineReducers } from 'redux';
import actionTypes from './actionTypes';

import { REDUCER_NAME, DATA_APPROVAL_STATUS, CSV_HEADERS } from './constants';

import viewReducer from './view/reducer';
import { REDUCER_NAME as VIEW_REDUCER_NAME } from './view/constants';

const initialState = {
  data: [],
  isFetching: true,
  previewData: {
    headers: Object.keys(CSV_HEADERS),
    data: [],
    status: DATA_APPROVAL_STATUS.INITIAL,
    errors: [],
  },
};

const sheetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        isFetching: true,
      };

    case actionTypes.FETCHING:
      return {
        ...state,
        isFetching: true,
      };

    case actionTypes.FETCHED:
      return {
        ...state,
        data: action.payload.data,
        isFetching: false,
      };
    case actionTypes.SET_PREVIEW_DATA: {
      return {
        ...state,
        previewData: {
          ...state.previewData,
          data: action.payload.data,
          status: DATA_APPROVAL_STATUS.INITIAL,
        },
      };
    }
    case actionTypes.APPROVE_PREVIEW_DATA: {
      return {
        ...state,
        previewData: {
          ...state.previewData,
          status: action.payload.status,
        },
      };
    }
    case actionTypes.SET_PREVIEW_ERRORS: {
      return {
        ...state,
        previewData: {
          ...state.previewData,
          errors: action.payload.errors,
        },
      };
    }

    default:
      return state;
  }
};

export default combineReducers({
  [REDUCER_NAME]: sheetsReducer,
  [VIEW_REDUCER_NAME]: viewReducer,
});
